module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Liczba kolumn",
      "error": _vm.errors['columns']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wskaż liczbę kolumn"
    },
    on: {
      "change": _vm.columnsChanged
    },
    model: {
      value: (_vm.form.columns),
      callback: function($$v) {
        _vm.$set(_vm.form, "columns", $$v)
      },
      expression: "form.columns"
    }
  }, _vm._l((_vm.maxColumns - 1), function(i) {
    return _c('el-option', {
      key: i + 1,
      attrs: {
        "label": i + 1,
        "value": i + 1
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.maxColumns), function(column) {
    return (_vm.form.columns && _vm.form.columns > column - 1) ? _c('el-form-item', {
      key: column,
      attrs: {
        "label": ("Kolumna " + column),
        "required": "",
        "error": _vm.errors[_vm.addLanguageSuffix(("column_" + column))]
      }
    }, [_c('wyswig-input', {
      model: {
        value: (_vm.form[_vm.addLanguageSuffix(("column_" + column))]),
        callback: function($$v) {
          _vm.$set(_vm.form, _vm.addLanguageSuffix(("column_" + column)), $$v)
        },
        expression: "form[addLanguageSuffix(`column_${column}`)]"
      }
    })], 1) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8fcd812"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/ColumnsWidget.vue
// module id = 800
// module chunks = 0